export default __webpack_public_path__ + "static/media/17-1-1.8957178c.gif";